import { ClientJS } from "clientjs";
import Cookies from "universal-cookie";

function checkIsClientAndroidNative() {
    const cookies = new Cookies();
    const params = new URLSearchParams(document.location.search);
    const isUrlClientAndroidNative = !!params.get('app_android');

    if (isUrlClientAndroidNative) {
        cookies.set('isClientAndroidNative', `${isUrlClientAndroidNative}`, { path: '/', maxAge: 60 * 60 * 24 * 7 });
        return true;
    }

    const isCookiesClientAndroid = cookies.get('isClientAndroidNative');
    if (isCookiesClientAndroid) {
        try {
            return !!JSON.parse(isCookiesClientAndroid);
        } catch (e) {
            return false;
        }
    }

    return false;
}

const clientJs = new ClientJS();
export const isClientSafari = clientJs.isSafari();
export const isClientMobile = clientJs.isMobile();
export const isClientAndroid = clientJs.isMobileAndroid();
export const isClientIOS = clientJs.isMobileIOS();
export const isClientAndroidNative = checkIsClientAndroidNative();
